import React, { useEffect } from 'react';
//infinity-observer
import { useInView } from 'react-intersection-observer';
//hooks
import useReservHook from 'src/webapp/hooks/reserv/reserv.hook';
//CompWrapper
import Section from 'src/webapp/views/wrapper/Section';
import Container from 'src/webapp/views/wrapper/Container';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
//Comp
import Menu from 'src/webapp/views/component/Menu';//메뉴
import Titlebar from 'src/webapp/views/component/Titlebar';//상단타이틀
import Search from './Search';//회원검색
import List from './List';//회원목록
import InViewData from 'src/webapp/views/component/data/InViewData';//데이터로드확인

export default function MemberReservList() {
    const {pageRef//무한로딩페이지DOM
        , searchRef//검색어DOM
        , scrollRef//elementScroll관리Ref
        , reservList//브랜드리스트데이터
        , reservListAPI//브랜드리스트API
    } = useReservHook();
    useEffect(() => {
        reservListAPI(1, 1);//예약목록API
    }, []);
    //infinityObserver
    const [ inViewRef, inView ] = useInView({ threshold: .5 });
    useEffect(() => {
        if (inView && (pageRef.current != null)) { reservListAPI(0, 1); }//예약목록API
    }, [inView]);

    return ( 
        <Section>
            <Menu />{/* 메뉴 */}
            <Container>
                <FixedPanel>
                    <Titlebar title={`예약목록`}  dept={[{label:'대시보드'}, {label:'예약 목록'}]} />{/* 상단타이틀 */}
                </FixedPanel>
                <FixedPanel>
                    <Search search={searchRef} onSearch={reservListAPI} />
                </FixedPanel>
                <FlickPanel>
                    <Element tag={`div`} className="fullHeight">
                    <List list={reservList} ref={scrollRef} />
                        {reservList.length > 0 && pageRef.current != null ? <div ref={inViewRef}><InViewData inView={true} /></div>
                        : reservList.length > 0 && pageRef.current === null ? <InViewData readAll={true} /> 
                        : null}
                    </Element>
                </FlickPanel>
            </Container>
        </Section>
    );
}